import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { Form } from 'formsy-react'
import styled from 'styled-components'
import { Button } from 'advenio-components'
import UnvalidatedReceiptsActions from '../../Data/Redux/UnvalidatedReceiptsRedux'
import { ReportHeader, ReportContainer } from '../../Components/ReportsComponents'
import { stringContainsExactlyOf } from '../../utils/Utils'

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: ${props => props["large"] ? 'row' : 'column'};
  padding: 16px;
  width: ${props => props.large ? '648px' : '400px'};
`

class UnvalidatedReceiptsReport extends Component {
  constructor(props) {
    super(props)
    this.state = {
      width: 0,
    }
  }

  componentDidMount() {
    this.updateWindowDimensions()
    window.addEventListener('resize', this.updateWindowDimensions)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions)
  }

  onChange = (model) => {
    this.setState()
  }

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth })
  }

  download = () => {
    const { getUnvalidatedReceiptsExcel, user } = this.props
    getUnvalidatedReceiptsExcel()
  }

  render() {
    const { width } = this.state
    const { loading } = this.props
    return (
      <ReportContainer>
        <ReportHeader>
          <span>Reporte de Recibos Sin Validar</span>
        </ReportHeader>
        <Form
          onChange={this.onChange}
        >
          <Container large={width > 768}>
            <Button marginRight="0" marginLeft="0" danger small onClick={this.download} loading={loading}>
              Descargar
            </Button>
          </Container>
        </Form>
      </ReportContainer>
    )
  }
}

const mapStateToProps = ({ centersInfo, auth, unvalidatedReceipts }) => ({
  activeCenter: centersInfo.center,
  user: auth.user,
  loading: unvalidatedReceipts.export.fetching,
})

const mapDispatchToProps = dispatch => ({
  getUnvalidatedReceiptsExcel: () =>
    dispatch(UnvalidatedReceiptsActions.exportRequest()),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(UnvalidatedReceiptsReport))



// WEBPACK FOOTER //
// ./src/Containers/Reports/UnvalidatedReceiptsReport.jsx